module.exports = __webpack_public_path__ + "img/default_img.1bd949a5.png";